import { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { buildAllRankingDefs } from "@/lib/rankings";
import { Link } from "react-router-dom";
import { getRestaurants } from "@/lib/store";
import { Trophy } from "lucide-react";

const RankingsPage = () => {
  const list = useMemo(() => getRestaurants().filter(r => !r.isWishlist), []);
  const defs = useMemo(() => buildAllRankingDefs(list), [list]);
  return (
    <div className="min-h-screen bg-background p-3 sm:p-4">
      <div className="container mx-auto max-w-6xl space-y-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold tracking-tight">ランキング</h1>
          <p className="text-sm text-muted-foreground">訪問済みのお店を、気分や目的ごとに見比べます。</p>
        </div>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
          {defs.map((d) => (
            <Link key={d.key} to={`/rankings/${d.key}`}>
              <Card className="h-full border-0 p-4 shadow-card transition hover:shadow-warm">
                <div className="mb-3 flex items-center gap-2">
                  <div className="grid h-9 w-9 place-items-center rounded-md bg-secondary">
                    <Trophy className="h-4 w-4 text-primary" />
                  </div>
                  <div className="min-w-0">
                    <div className="truncate text-lg font-semibold">{d.title}</div>
                    <div className="text-xs text-muted-foreground">{list.length}件から集計</div>
                  </div>
                </div>
                <div className="line-clamp-2 text-sm text-muted-foreground">{d.description}</div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RankingsPage;
